define('components/popin/models/PopinModel', [

], function() {

    var PopinModel = Backbone.Model.extend({
        defaults: {
            "attach": "body",                       // Selector $ to attach popin
            "popinType": "popin",                   // Type of popin ( "popin" || "expand" )
            "popinSurtitle": "",                    // Surtitle of popin. If empty -> hidden
            "popinTitle": "",                       // Title of popin. If empty -> hidden
            "popinSubtitle": "",                    // Subtitle of popin. If empty -> hidden
            "withCloseButton": true,                // Show / Hide close button
            "withBackToTopButton": false,           // Show / Hide Back to top button
            "view": "<div>empty</div>",             // View to display into popin
            "overlayCustomClass": "",               // Add class to overlay
            "popinCustomClass": "",                 // Custom css class
            "popinScrollMode": "internal",          // Scroll mode of popin ( "internal" || "external" || "native" )
            "popinViewClass": "",                   // Css class for default style ( "viewerview" || "videoproductview" || "multiproductsview" || "shareview" || "videoview" )
            "onContentReadyCallback": null,         // Callback when view is ready
            "onBeforeCloseCallback": null,          // Callback on before close popin
            "onCloseCallback": null,                // Callback on close popin
            "onManualCloseCallback": null,          // Callback on manual close popin
            "animation": false,                     // Callback on manual close popin
            "previousPopinUrl": null,               // Previous popin url. If empty block is hidden
            "previousPopinLabel": "",               // Previous popin label
            "previousPopinInactive": false,         // If true show previous block but cannot click
            "nextPopinUrl": null,                   // Next popin url. If empty block is hidden
            "nextPopinLabel": "",                   // Next popin label
            "nextPopinInactive": false              // If true show next block but cannot click
        }
    });

    return PopinModel;
});
